"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NWP_READY_STATE_TIMEOUT = 10000;
/**
 * This class handles the NWP client.
 */

var NwpPlatformClient = /*#__PURE__*/function () {
  /**
   * Class constructor.
   */
  function NwpPlatformClient() {
    _classCallCheck(this, NwpPlatformClient);

    this._source = null;
    this._origin = null;
    this._apiId = null;
    this._requestId = 0;
    this._resolves = [];
    this._rejects = [];
    this._timeout = null;
  }
  /**
   * Starts listening.
   */


  _createClass(NwpPlatformClient, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      if (window.addEventListener) {
        window.addEventListener('message', function (event) {
          if (typeof event.data === 'string' && event.data.includes('"state":"ready"') && event.data.includes('"apiId"')) {
            var data = JSON.parse(event.data);
            _this._source = event.source;
            _this._origin = event.origin;
            _this._apiId = data.apiId;

            var _iterator = _createForOfIteratorHelper(_this._resolves),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var resolve = _step.value;
                resolve();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _this._resolves = [];
            _this._rejects = [];
          }
        });
      }
    }
    /**
     * Posts to IWF.
     *
     * @param {Object} data Data object.
     * @param {String} data.namespace NWP namespace.
     * @param {String} data.method NWP method.
     * @param {Object} data.parameters NWP parameters.
     * @return {Promise} Promise object.
     */

  }, {
    key: "post",
    value: function post(data) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var postMessage = function postMessage() {
          clearTimeout(_this2._timeout);
          data.apiId = _this2._apiId;
          data.requestId = _this2._requestId;
          _this2._requestId++;

          _this2._source.postMessage(JSON.stringify(data), _this2._origin);

          resolve();
        };

        clearTimeout(_this2._timeout);

        if (_this2._source) {
          setTimeout(postMessage);
        } else {
          _this2._resolves.push(postMessage);

          _this2._rejects.push(reject);

          _this2._timeout = setTimeout(function () {
            var _iterator2 = _createForOfIteratorHelper(_this2._rejects),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _reject = _step2.value;

                _reject(new Error('Failed to send platform post data. No ready state was recieved from NWP page.'));
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            _this2._resolves = [];
            _this2._rejects = [];
          }, NWP_READY_STATE_TIMEOUT);
        }
      });
    }
  }]);

  return NwpPlatformClient;
}();

exports.default = NwpPlatformClient;